<template>
    <div>
        <h1 v-if="mobileSubscriptions.length" class="font-weight-light text-center">Líneas Móviles</h1>
        <v-card class="my-2" v-for="mobileline in mobileSubscriptions" :key="mobileline.id">
            <v-card-title>
                <h5 class="font-weight-light">{{mobileline.tariffName}}</h5>
                <v-spacer></v-spacer>
                <v-btn depressed color="primary" class="font-weight-light">{{mobileline.msisdn}}</v-btn>
            </v-card-title>

            <v-card-text>
                <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between' : 'text-center'">
                    <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex align-center' : 'd-flex justify-center my-1'">
                        <h5 class="font-weight-light">Estado</h5>
                        <v-icon
                            class="ml-2"
                            right
                            :small="$vuetify.breakpoint.smAndDown"
                            :color="mobileline.status === 'ACTIVATED' ? 'green' : 'red'"
                        >
                            mdi-circle
                        </v-icon>
                    </div>
                    <AgentSIMInfoDialog :mobileline="mobileline" />
                    <AgentUserInfo :expeditionUserInfo="mobileline.expeditionUserInfo" />
                </div>

                <v-divider class="my-2"></v-divider>

                <AgentPromos :selectedContractId="selectedContractId" :serviceID="mobileline.id" serviceType="mobileSubscriptions" />

                <v-divider class="my-2"></v-divider>
                
                <AgentPenalties class="d-flex flex-wrap justify-center" :selectedContractId="selectedContractId" :serviceNumber="mobileline.msisdn" :types="['POSTPAID']"/>
                
                <v-divider class="my-2"></v-divider>

                <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between' : ''">
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Tarifa</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>Nombre:</strong> {{ mobileline.tariffName }}</h5>
                            <!-- <h5 class="font-weight-light grey--text"><strong>ID:</strong> {{ mobileline.tariffId }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Segmento:</strong> {{ mobileline.offerSegment }}</h5> -->
                            <h5 class="font-weight-light grey--text"><strong>Origen:</strong> {{ mobileline.origin }}</h5>
                        </div>
                    </div>
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Portabilidad</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Operación:</strong> {{ mobileline.portabilityInfo.operationDate }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Estado:</strong> {{ mobileline.portabilityInfo.portabilityStatus }}</h5>
                        </div>
                    </div>
                </div>

                <v-divider class="my-2"></v-divider>

                <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between' : ''">
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Línea</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>Estado:</strong> {{ mobileline.status }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Subtipo:</strong> {{ mobileline.subType }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Segmento:</strong> {{ mobileline.segmentType }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Activación:</strong> {{ formatDateYYYYMMDD(mobileline.metadataInfo.activationDate) }}</h5>
                        </div>
                    </div>
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Línea</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Desactivación:</strong> {{ formatDateYYYYMMDD(mobileline.metadataInfo.deactivationDate) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Razón de Desactivación:</strong> {{ mobileline.metadataInfo.deactivationReason }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Instalación:</strong> {{ formatDateYYYYMMDD(mobileline.metadataInfo.installationDate) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Venta:</strong> {{ formatDateYYYYMMDD(mobileline.metadataInfo.sellDate) }}</h5>
                        </div>
                    </div>
                </div>

                <!-- <v-divider class="my-2"></v-divider>

                <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between' : ''">
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de Consumo</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>Consumo de Llamadas:</strong> {{ mobileline.callConsumptionInfo ? mobileline.callConsumptionInfo.totalAmount : 'No disponible' }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Consumo de Datos:</strong> {{ mobileline.internetConsumptionInfo ? mobileline.internetConsumptionInfo.totalAmount : 'No disponible' }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Inicio:</strong> {{ formatDateYYYYMMDD(mobileline.callConsumptionInfo.from) }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Fin:</strong> {{ formatDateYYYYMMDD(mobileline.callConsumptionInfo.to) }}</h5>
                        </div>
                    </div>
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de Consumo</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>Consumo de Llamadas:</strong> {{ mobileline.callConsumptionInfo ? mobileline.callConsumptionInfo.totalAmount : 'No disponible' }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Consumo de Datos:</strong> {{ mobileline.internetConsumptionInfo ? mobileline.internetConsumptionInfo.totalAmount : 'No disponible' }}</h5>
                        </div>
                    </div>
                </div> -->


                <!-- <v-divider class="my-2"></v-divider>

                <div :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between' : ''">
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Tarjeta Prepago</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>Saldo:</strong> {{ mobileline.prepaidBalance }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Listo para Facturar:</strong> {{ mobileline.readyForBillingDate }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Listo para Servicio:</strong> {{ mobileline.readyForServiceDate }}</h5>
                        </div>
                    </div>
                    <div>
                        <h3 class="font-weight-light mt-4 mb-2"><strong>Información de la Tarjeta Prepago</strong></h3>
                        <div class="d-flex flex-column justify-center">
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Retroportabilidad:</strong> {{ mobileline.retroportabilityInfo }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>Fecha de Cambio de Tarifa Programado:</strong> {{ mobileline.scheduledTariffChangeInfo.date }}</h5>
                            <h5 class="font-weight-light grey--text"><strong>¿Tiene Cambio de Tarifa Programado?:</strong> {{ mobileline.scheduledTariffChangeInfo.hasScheduledTariffChange }}</h5>
                        </div>
                    </div>
                </div> -->

            </v-card-text>
            <v-card-actions :class="!$vuetify.breakpoint.smAndDown ? 'd-flex justify-space-between align-center' : 'd-flex flex-column'">
                <v-btn
                    x-small
                    depressed
                    outlined
                    color="primary"
                    class="mb-2"
                    @click="agentContract(mobileline.contractUrl.split('/').pop()); isOpen = true;"
                >
                    <v-icon small left>mdi-file-document</v-icon>
                    Ver Contrato
                </v-btn>
                <AgentUserInfo :expeditionUserInfo="mobileline.ownerUserInfo" :title="'Información del Propietario'" />
            </v-card-actions>
        </v-card>
    </div>
</template>

<script>
import AgentUserInfo from './AgentUserInfo.vue';
import AgentSIMInfoDialog from './AgentSIMInfoDialog.vue';
import AgentPenalties from './AgentPenalties.vue';
import AgentPromos from './AgentPromos.vue';
import { mapActions } from 'vuex';
import { formatDateYYYYMMDD } from '@/util/libUtil.js';

export default {
    components: {
        AgentUserInfo,
        AgentSIMInfoDialog,
        AgentPromos,
        AgentPenalties,
    },
    props: {
        mobileSubscriptions: {
            type: Array,
        },
        selectedContractId: {
            type: String,
        },
    },
    methods: {
        formatDateYYYYMMDD,
        ...mapActions('agent', ['agentContract']),
    },
};
</script>
